import { api } from "../api";
import { EventResponse } from "../../../types/types";

type RecentVehicleEventsResponse = {
    events: EventResponse[];
    cursor: number;
    hasMore: boolean;
};

const findRecentEventsByVehicle = async (
    token: string,
    customerId: number,
    vehicleId: number,
    afterId: number
): Promise<RecentVehicleEventsResponse> => {
    const response = await api.get<RecentVehicleEventsResponse>(
        `/events/${customerId}/vehicles/${vehicleId}/recent`,
        { params: { afterId }, headers: { Authorization: `Bearer ${token}` } }
    );
    return response.data;
};

export default findRecentEventsByVehicle;
